import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Contact } from 'app/entities/contact';
import { guardDialogClose } from 'app/helpers/discard-guard';
import { emailAddress } from 'app/helpers/validators';
import { ClientsService } from 'app/main/pages/clients/clients.service';
import { AlertService } from 'app/services/alert.service';
import { GtagService } from 'app/services/gtag.service';

export interface ClientContactDialogData {
    clientId: number;
    contact?: Contact | null;
}

// Novo/Editar contato do cliente (ORCA-1886). Abrir com oaDialogConfig('fullscreen').
@Component({
    selector: 'app-client-contact-dialog',
    templateUrl: './client-contact-dialog.component.html',
    styleUrls: ['./client-contact-dialog.component.scss'],
})
export class ClientContactDialogComponent {

    form: FormGroup;
    loading = false;
    readonly contact?: Contact | null;
    readonly requestClose: () => void;

    constructor(
        public dialogRef: MatDialogRef<ClientContactDialogComponent, Contact>,
        @Inject(MAT_DIALOG_DATA) public data: ClientContactDialogData,
        private _dialog: MatDialog,
        private _formBuilder: FormBuilder,
        private _clientService: ClientsService,
        private _alertService: AlertService,
        private _gtag: GtagService,
    ) {
        this.contact = data.contact;
        this.form = this._formBuilder.group({
            name: [this.contact?.name, [Validators.required]],
            email: [this.contact?.email, [Validators.required, emailAddress()]],
            phone: [this.contact?.phone, []],
            role: [this.contact?.role, []],
            clientId: [data.clientId, []],
        });
        this.requestClose = guardDialogClose(dialogRef, _dialog, () => this.form.dirty, () => this.loading);
    }

    save() {
        if (this.form.invalid || this.loading) {
            this.form.markAllAsTouched();
            return;
        }

        const value = { ...this.form.value, email: this.form.value.email?.trim() };
        const request = this.contact?.id
            ? this._clientService.updateContact(this.data.clientId, this.contact.id, value)
            : this._clientService.addContacs(this.data.clientId, value);

        this.loading = true;
        request.subscribe((res: any) => {
            this.loading = false;
            this._alertService.success('Contato salvo com sucesso.');
            this.trackSaved(res, value);
            this.dialogRef.close(res);
        }, (error) => {
            this.loading = false;
            this._alertService.error(error);
        });
    }

    private trackSaved(res: any, value: any) {
        const isUpdate = !!this.contact?.id;
        this._gtag.event(isUpdate ? 'client_contact_update' : 'client_contact_create', {
            event_category: 'crm',
            event_label: isUpdate ? 'Contato do cliente atualizado' : 'Contato do cliente criado',
            client_id: this.data.clientId,
            contact_id: res?.id ?? this.contact?.id,
            has_email: !!value?.email,
            has_phone: !!value?.phone,
        });
    }
}
